import React, { Component } from 'react'
import styled from 'styled-components'

// config and utils
import th from 'utils/themeHelper'
import l from 'config/localization'

// Load components synchronously
import ConditionalDisplay from 'components/ConditionalDisplay/ConditionalDisplay'

const snapAgent = navigator.userAgent === 'ReactSnap'

const ActionLink = styled.div`
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
`

const HeaderBar = styled.div`
  background-color: ${th('primary.light')};
  width: 100%;
  height: 10px;

  @media screen and (min-width: 769px) {
    display: none;
  }
`

const HeaderContainerInner = styled.div`
  padding: 10px;

  @media screen and (min-width: 769px) {
    padding: 10px 20px;
  }

  @media screen and (min-width: 1024px) {
    padding: 10px 20px;
  }
`

const HeaderContainer = styled.div`
  background-color: white;
  border-color: ${th('primary.light')};
  border-style: solid;
  border-width: 2px;
  line-height: 1.25em;
  margin: ${props => (props.displayFormBar ? '0' : '20px 0 20px')};
  position: ${props => (props.displayFormBar ? 'fixed' : 'relative')};
  top: ${props => (props.displayFormBar ? '65px' : '0')};
  width: 100%;
  z-index: ${props => (props.displayFormBar ? '9999' : '1')};

  @media screen and (min-width: 769px) {
    margin: ${props => (props.displayFormBar ? '0' : '0 0 20px 0')};
  }
`

class EmailConfirmationBanner extends Component {
  state = { emailConfirmationRequested: false }

  sendConfirmationEmail() {
    this.props.requestConfirmationEmail()
    this.setState({ emailConfirmationRequested: true })
  }

  render() {
    if (snapAgent) return null
    const { emailConfirmationRequested } = this.state

    return (
      <HeaderContainer {...this.props}>
        <HeaderBar />

        <HeaderContainerInner>
          <ConditionalDisplay displayWhen={[emailConfirmationRequested]}>
            <div>You should receive an account activation email shortly.</div>
          </ConditionalDisplay>

          <ConditionalDisplay displayWhen={[!emailConfirmationRequested]}>
            <div>
              Please check your email inbox and spam folders, and confirm your email address to add{' '}
              {l('OPPS')} or {l('CAMPS')}.{' '}
              <ActionLink onClick={() => this.sendConfirmationEmail()}>
                Click here to re-send the activation email
              </ActionLink>
              .
            </div>
          </ConditionalDisplay>
        </HeaderContainerInner>
      </HeaderContainer>
    )
  }
}

export default EmailConfirmationBanner
